const HTML_TAG = /<[a-z/!][^>]*>/i;

const ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
};

function escapeText(text: string): string {
  return text.replace(/[&<>]/g, (char) => ESCAPES[char] ?? char);
}

export function plainTextToHtml(value: string): string {
  if (value === "" || HTML_TAG.test(value)) {
    return value;
  }

  return value
    .split(/\r?\n/)
    .map((line) => `<p>${line === "" ? "<br>" : escapeText(line)}</p>`)
    .join("");
}

const UNESCAPES: Record<string, string> = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&nbsp;": " ",
  "&quot;": '"',
  "&#39;": "'",
};

function unescapeText(text: string): string {
  return text.replace(
    /&(?:amp|lt|gt|nbsp|quot|#39);/g,
    (entity) => UNESCAPES[entity] ?? entity,
  );
}

export function htmlToPlainText(value: string): string {
  if (!HTML_TAG.test(value)) {
    return value;
  }

  return unescapeText(
    value
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/(?:p|div|li|h[1-6])>/gi, "\n")
      .replace(/<li[^>]*>/gi, "- ")
      .replace(/<[^>]+>/g, ""),
  )
    .replace(/\n{3,}/g, "\n\n")
    .replace(/\s+$/, "");
}
